(function (app) {

    app.filter("ageFilter",
        function () {          
            function calculateAge(dob) {               
                var birthDate = new Date(dob);
                var today = new Date().setHours(0, 0, 0, 0);  //set to midnight of current date                          
                var diff = today - birthDate;	// Difference in milliseconds from midnight of birthday to midnight of current date             
                return Math.floor(diff / 31557600000); // Divide by 1000*60*60*24*365.25 <- length of a year (365 days and 6 hours) in milliseconds               
            }

            return function (dob) {
                return calculateAge(dob);
            };
        });

})(window.app); //jshint ignore:line